
import { Button, Popconfirm, Typography, message } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";


import { useState } from "react";
import { useDispatch } from 'react-redux';

import { deleteStaff } from '../../redux/rtk/features/user/userSlice';
import getUserFromToken from '../../utils/getUserFromToken';


const { Title, Paragraph } = Typography;

function ProfileDelete() {
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const id = getUserFromToken();

    const dispatch = useDispatch();


    const onDelete = async () => {
        try {
            const response = await dispatch(deleteStaff(id));
            if (response.payload.message === "success") {
                setLoader(false);
            }
            toast.success("Profile successfully deleted");
            setLoader(false);

        } catch (error) {
            toast.error("Failed to delete profile");
            console.log("not deleted");
            setLoader(false);

        }
    };

    const onCancel = () => {
        message.info("Profile deletion canceled");
    };

    return (
        <div style={{ padding: '20px', maxWidth: '600px', margin: 'auto' }}>
            <Title level={2}>Important Notice: Profile Deletion</Title>
            <Paragraph>
                Deleting your profile is a <strong>serious</strong> and <strong>irreversible</strong> action. By proceeding, you will permanently lose access to all of your personal data, including but not limited to:
            </Paragraph>
            <Paragraph>
                <ul>
                    <li>All account details and associated information.</li>
                    <li>All your preferences, settings, and saved configurations.</li>
                    <li>Access to any personalized services, applications, and subscriptions linked to this profile.</li>
                    <li>All stored data such as documents, media, and messages.</li>
                    <li>Historical records, activity logs, and any contributions made within the platform.</li>
                </ul>
            </Paragraph>
            <Paragraph>
                Once deleted, <strong>this action cannot be undone</strong>, and there will be no way to recover any of your data or information. You will need to create a new profile to regain access to our services, but your previous data will not be retrievable.
            </Paragraph>
            <Paragraph>
                If you are sure you want to permanently delete your profile, click "Confirm Delete." If you have any concerns, it is highly recommended that you back up any important data before proceeding. For further assistance, feel free to contact support.
            </Paragraph>
            <Paragraph>
                Please note: Profile deletion does not remove any legal obligations or agreements you may have with the service, such as outstanding payments or responsibilities.
            </Paragraph>

            <Popconfirm
                title="Are you sure you want to delete your profile?"
                onConfirm={onDelete}
                onCancel={onCancel}
                okText="Yes, Delete"
                cancelText="Cancel"
            >
                <Button type="primary" danger>
                    Confirm Delete Profile
                </Button>
            </Popconfirm>
        </div>
    );
}

export default ProfileDelete;